//@flow
import * as Immutable from 'immutable';

import {
    ClientSettingsResponse,
    ClientSettingsRequest,
    VAEConfiguration,
    ClientSettings
} from 'platform/settings/models/flow/ClientSettings';

import type {
    ClientSettingsResponseModelType,
    ClientSettingsRequestModelType,
    VAEConfigurationModelType,
    ClientSettingsModelType
} from 'platform/settings/models/flow/ClientSettings';

class InternalClientSettingsResponse extends ClientSettingsResponse {
    static fromJS(
        json: ClientSettingsResponseModelType
    ): InternalClientSettingsResponse {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalClientSettingsRequest extends ClientSettingsRequest {
    static fromJS(
        json: ClientSettingsRequestModelType
    ): InternalClientSettingsRequest {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalVAEConfiguration extends VAEConfiguration {
    static fromJS(json: VAEConfigurationModelType): InternalVAEConfiguration {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalClientSettings extends ClientSettings {
    static fromJS(json: ClientSettingsModelType): InternalClientSettings {
        const state: Object = Object.assign({}, json);
        state.vaeConfiguration = state.vaeConfiguration
            ? InternalVAEConfiguration.fromJS(state.vaeConfiguration)
            : state.vaeConfiguration;
        return new this(Immutable.Map(state));
    }

    get vaeConfiguration(): ?InternalVAEConfiguration {
        return this._state.get('vaeConfiguration');
    }
}

export {
    InternalClientSettingsResponse as ClientSettingsResponse,
    InternalClientSettingsRequest as ClientSettingsRequest,
    InternalVAEConfiguration as VAEConfiguration,
    InternalClientSettings as ClientSettings
};
